export type UCQType = {
  value: string;
  label: string;
};

export const UNIQUE_QUANTITY_CODES_LIST: UCQType[] = [
  {
    value: "BAG",
    label: "Bags (BAG)",
  },
  {
    value: "BAL",
    label: "Bale (BAL)",
  },
  {
    value: "BDL",
    label: "Bundles (BDL)",
  },
  {
    value: "BKL",
    label: "Buckles (BKL)",
  },
  {
    value: "BOU",
    label: "Billions Of Units (BOU)",
  },
  {
    value: "BOX",
    label: "Box (BOX)",
  },
  {
    value: "BTL",
    label: "Bottles (BTL)",
  },
  {
    value: "BUN",
    label: "Bunches (BUN)",
  },
  {
    value: "CAN",
    label: "Cans (CAN)",
  },
  {
    value: "ct.",
    label: "Carats (ct.)",
  },
  {
    value: "CTN",
    label: "Carton (CTN)",
  },
  {
    value: "CCM",
    label: "Cubic Centimeter (CCM)",
  },
  {
    value: "CBM",
    label: "Cubic meter (CBM)",
  },
  {
    value: "CMS",
    label: "Centimeter (CMS)",
  },
  {
    value: "DRM",
    label: "Drum (DRM)",
  },
  {
    value: "DOZ",
    label: "Dozen (DOZ)",
  },
  {
    value: "DRM",
    label: "Drum (DRM)",
  },
  {
    value: "GGR",
    label: "Great Gross (GGR)",
  },
  {
    value: "GYD",
    label: "Gross Yards (GYD)",
  },
  {
    value: "GMS",
    label: "Grams (GMS)",
  },
  {
    value: "GRS",
    label: "Gross (GRS)",
  },
  {
    value: "KGS",
    label: "Kilograms (KGS)",
  },
  {
    value: "KLR",
    label: "Kiloliter (KLR)",
  },
  {
    value: "KME",
    label: "Kilometre (KME)",
  },
  {
    value: "MLT",
    label: "Millilitre (MLT)",
  },
  {
    value: "MTR",
    label: "Meters (MTR)",
  },
  {
    value: "MTS",
    label: "Metric Tons (MTS)",
  },
  {
    value: "NOS",
    label: "Numbers (NOS)",
  },
  {
    value: "PAC",
    label: "Packs (PAC)",
  },
  {
    value: "PCS",
    label: "Pieces (PCS)",
  },
  {
    value: "PRS",
    label: "Pairs (PRS)",
  },
  {
    value: "QTL",
    label: "Quintal (QTL)",
  },
  {
    value: "ROL",
    label: "Rolls (ROL)",
  },
  {
    value: "SET",
    label: "Sets (SET)",
  },
  {
    value: "SQF",
    label: "Square Feet",
  },
  {
    value: "SQM",
    label: "Square Meters (SQM)",
  },
  {
    value: "SQY",
    label: "Square Yards (SQY)",
  },
  {
    value: "TBS",
    label: "Tablets (TBS)",
  },
  {
    value: "TGM",
    label: "Ten Gross (TGM)",
  },
  {
    value: "THD",
    label: "Thousands (THD)",
  },
  {
    value: "TON",
    label: "Tonnes (TON)",
  },
  {
    value: "TUB",
    label: "Tubes (TUB)",
  },
  {
    value: "UGS",
    label: "US Gallons (UGS)",
  },
  {
    value: "UNT",
    label: "Units (UNT)",
  },
  {
    value: "YDS",
    label: "Yards (YDS)",
  },
  {
    value: "LTR",
    label: "Litre (LTR)",
  },
  {
    value: "OTH",
    label: "Others",
  },
];
